// extracted by mini-css-extract-plugin
export default {"FcmGalleryDialogContent":"FcmGalery_FcmGalleryDialogContent_wVVQB"};